<template>
    <MaterialSheetForecast></MaterialSheetForecast>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const MaterialSheetForecast = defineAsyncComponent(() =>
    import("../../components/CNC/MaterialForecast/MaterialSheetForecast.vue")
);

export default {
    name: "CNC_MaterialSheetForecast", //The name you are in should not equal the name of the component you are importing.
    components: { MaterialSheetForecast, AuthLayout },
};
</script>
